// T-195 (v1.8.66): als ERSTER Import in index.tsx, damit kein anderes Modul beim Laden auf einen gesperrten Speicher zugreift.
import { speicherAbsichern } from './utils/sichererSpeicher';

const ersetzt = speicherAbsichern(window);
if (ersetzt.length > 0) {
  console.warn(`Browser-Speicher gesperrt (${ersetzt.join(', ')}), Speicher im Arbeitsspeicher bis zum Neuladen der Seite`);
}

export {};
